import * as React from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { useReviewsProductGroupDataContext } from '../../../../../containers/ReviewsProductGroupDataService/useReviewsProductGroupData'

export function useViewModel({ writeReview }: { writeReview: boolean }) {
  const {
    magnolia: {
      reviewsPage: { thankYouHeadline, thankYouParagraph },
    },
  } = useTranslation()
  const { error } = useReviewsProductGroupDataContext()

  const [reviewSubmitted, setReviewSubmitted] = React.useState<boolean>(false)

  const [showForm, setShowForm] = React.useState<boolean>(writeReview)

  const toggleForm = React.useCallback(() => {
    setShowForm(current => !current)
  }, [])

  const [thankYouDismissed, setThankYouDismissed] = React.useState<boolean>(false)

  const dismissThankYou = React.useCallback(() => {
    setThankYouDismissed(true)
  }, [])

  const hideAndDisableReviewForm = React.useCallback(() => {
    setShowForm(false)
    setReviewSubmitted(true)
  }, [])

  return {
    didQueryFail: !!error,
    dismissThankYou,
    hideAndDisableReviewForm,
    reviewSubmitted,
    showForm,
    thankYouDismissed,
    thankYouHeadline,
    thankYouParagraph,
    toggleForm,
  }
}
